import { render } from "./RuiDelete.vue?vue&type=template&id=0ed2f9e2"
const script = {}
script.render = render

export default script